<template>
    <section class="login">
        <div class="login-card">
            <img class="login-logo" src="../assets/img/logo_bul.png" alt="Logo" />

            <h1 class="login-title">Welcome back</h1>
            <p class="login-subtitle">
                Accedi utilizzando il tuo account Microsoft
            </p>

            <button
                class="microsoft-login"
                @click.prevent="loginWithMicrosoft"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                    alt="Microsoft"
                />
                <span>Login with Microsoft</span>
            </button>

            <p v-if="errorMessage" class="login-error">
                {{ errorMessage }}
            </p>
        </div>
    </section>
</template>




<script>
import { mapGetters, mapActions } from 'vuex'
import msalInstance from '../msal';

export default {
    name: 'login',
    data () {
        return {
            email: '',
            password: '',
            errorMessage: ''  // nuovo stato per gestire errori
        }
    },
    computed: {
        ...mapGetters(['isAuthenticated']),
        baseUrl() {
            let url = process.env.VUE_APP_API_URL || '';
            if (url.endsWith('/api/')) {
                url = url.slice(0, -5);
            }
            return url;
        },
    },
    methods: {
        ...mapActions({
            logout: 'logout'
        }),
        async loginWithMicrosoft () {
            this.errorMessage = ''; // Reset messaggi errore

            try {
                const loginResponse = await msalInstance.loginPopup({
                    scopes: ['openid', 'profile', 'email', 'User.Read'] // MS Graph scopes base
                });

                const account = loginResponse.account;
                if (!account) {
                    this.errorMessage = 'Impossibile ottenere l\'account Microsoft.';
                    return;
                }
                // Se tutto ok, effettua il login
                this.$store.dispatch('microsoftLogin', {
                    urlToConnect: 'login_microsoft',
                    methodToConnect: 'post',
                    idToken: loginResponse.idToken
                }).then(() => {
                    this.email = ''
                    this.password = ''
                    this.$router.replace('/dashboard')
                })
                .catch(err => {
                    this.errorMessage = 'Credenziali non valide.'
                })



            } catch (err) {
                console.error('Microsoft login error:', err);
                this.errorMessage = 'Errore durante l\'accesso con Microsoft.';
            }

        },
        login () {
            // Reset messaggio errore
            this.errorMessage = ''

            // Validazione email
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!this.email || !emailRegex.test(this.email)) {
                this.errorMessage = 'Inserisci un\'email valida.'
                return
            }

            // Validazione password
            if (!this.password) {
                this.errorMessage = 'La password non può essere vuota.'
                return
            }

            this.$store.dispatch('login', {
                urlToConnect: 'login',
                methodToConnect: 'post',
                email: this.email,
                password: this.password
            })
                .then(() => {
                    this.email = ''
                    this.password = ''
                    this.$router.replace('/dashboard')
                })
                .catch(err => {
                    this.errorMessage = 'Credenziali non valide.'
                })
        }
    },
    created () {
        if (this.$store.getters.isAuthenticated) {
            this.$router.replace('/dashboard')
        }
    }
}
</script>

